import { trackingClient } from '../clients'
import { TrackingEvent } from '../transports/tracking-transport'

export const trackEvents = (events: TrackingEvent[]) => {
    trackingClient.trackEvents({ trackingEvents: events }).then()
}
